.layer {
  position: absolute;
  pointer-events: none;
  z-index: 0;
  animation: fadeIn 1.4s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.canvas {
  position: absolute;
  left: -70%;
  top: -35%;
  width: 240%;
  height: 170%;
  pointer-events: none;
  animation: fadeIn 1.4s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.back {
  z-index: 0;
}

.front {
  z-index: 2;
}

.breathe,
.halo {
  inset: -28% -62%;
  background: radial-gradient(closest-side, color-mix(in srgb, var(--fc-halo) 55%, transparent), transparent);
}

.breathe {
  animation:
    fadeIn 1.4s cubic-bezier(0.4, 0, 0.2, 1) both,
    breathe 3.2s ease-in-out infinite;
}

.slow {
  opacity: 0.6;
  animation:
    fadeIn 1.4s cubic-bezier(0.4, 0, 0.2, 1) both,
    breathe 5s ease-in-out infinite;
}

.halo {
  background: radial-gradient(closest-side, var(--glow), transparent);
}

.aurora {
  width: 112%;
  aspect-ratio: 1;
  border-radius: 50%;
  filter: blur(30px);
  opacity: 0.7;
  animation:
    fadeIn 1.4s cubic-bezier(0.4, 0, 0.2, 1) both,
    aurora 9s ease-in-out infinite alternate;
}

.warm {
  animation-duration: 1.2s, 12s;
}

.a1 {
  background: #e8b04a;
  left: -50%;
  top: -11%;
}

.a2 {
  background: #d9674f;
  right: -56%;
  top: 32%;
  animation-delay: 0s, -3s;
}

.a3 {
  background: #5fae9a;
  left: -19%;
  bottom: -25%;
  animation-delay: 0s, -6s;
}

.warm.a1 {
  background: #f2c46b;
}

.warm.a2 {
  background: #e89a5a;
}

.warm.a3 {
  background: #e7a3a0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
}

@keyframes breathe {
  0%,
  100% {
    opacity: 0.55;
    transform: scale(0.9);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes aurora {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(30px, -20px) scale(1.2);
  }
  100% {
    transform: translate(-20px, 24px) scale(0.9);
  }
}
